

import React, {useState, useEffect} from 'react';
import { createBrowserHistory } from 'history';

import Trade from './Trade'; 

import variables from './variables';
import links from './coinApi';
import logo from '../images/vhions logo.png';
import menuIcon from '../images/menu-icon.png';
import menuIconx from '../images/menu-iconx.png';
import searchicon from '../images/search-icon.png';
import caretup from '../images/caret-up.png';
import caretdown from '../images/caret-downn.png';
import rocket from '../images/rockett.png';
import twitter from '../images/twitter-icon.png';
import gmail from '../images/gmail.png';
import facebook from '../images/facebook.png';
import step1 from '../images/step1b.png';
import step2 from '../images/step2.png' ;
import step3 from '../images/step3.png';
import axios from 'axios';
import Coin from './coin';
import BannerCoin from './bannercoin';




function App() {
    const history = createBrowserHistory();
    const open = menuIcon;
    const close = menuIconx;
    const caretDown = caretdown;
    const caretUp = caretup;
    const up = '↑';
    const down = '↓';
    const h1 = '25px';
    const h2 = '30px';
    const block = 'block';
    const none = 'none';
    const gold = 'transparent';
    const blue = 'blue';
    const nairaRate = variables.naira; 

       
       const[menuIconState, setMenuIconState] = useState(open); 
       const[menuState, setMenuState] = useState(none);
       const[menuColor, setMenuColor] = useState(gold);
       const[menuHeight, setMenuHeight] = useState(h1);


       // converter section start
       
       const[caretTo, setCaretTo] = useState(caretDown);
       const[searchList, setSearchList] = useState('');
       const[coinList, setCoinList] = useState(none);
       const[coinSelect, setCoinSelect] = useState('USDT');
       const[price, setPrice] = useState(nairaRate);
       

       const[amount, setAmount] = useState(nairaRate);
       const[amountInputFrom, setAmountInputFrom] = useState(true);


       // converter section end

       const[bannercoins, setBannercoins] = useState([]);
       const[coins0, setCoins0] = useState([]);
       const[coins1, setCoins1] = useState([]);
       const[coins2, setCoins2] = useState([]);
       const[coins3, setCoins3] = useState([]);
       const[coins4, setCoins4] = useState([]);
       const[coins5, setCoins5] = useState([]);
       const[coins6, setCoins6] = useState([]);
       const[coins7, setCoins7] = useState([]);

       const[search, setSearch] = useState('');


       // FAQ SECTION

       const[arrow1, setArrow1] = useState(down);
       const[arrow2, setArrow2] = useState(down);
       const[arrow3, setArrow3] = useState(down);
       const[arrow4, setArrow4] = useState(down);
       const[arrow5, setArrow5] = useState(down);
       const[arrow6, setArrow6] = useState(down);
       const[arrow7, setArrow7] = useState(down);

       // FAQ SECTION END
       let fromAmount, toAmount;
       
      if(amountInputFrom) {
          fromAmount = amount;
          toAmount = amount / price;
          
          
      } else {
          toAmount = amount;
          fromAmount = amount * price;
            
      }

  

    useEffect( () => {

        

        function bannerCoin() {
            axios.get('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=20&page=1&sparkline=false')
            .then(res => {
                setBannercoins(res.data)
            })
            .catch(error => console.log(error))
        };
      
    function lnk0() {
           axios.get(links[0])
           .then( res => {
           setCoins0(res.data)
           })
           .catch( error => console.log(error));
        }
        function lnk1() {
            axios.get(links[1])
            .then( res => {
            setCoins1(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk2() {
            axios.get(links[2])
            .then( res => {
            setCoins2(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk3() {
            axios.get(links[3])
            .then( res => {
            setCoins3(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk4() {
            axios.get(links[4])
            .then( res => {
            setCoins4(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk5() {
            axios.get(links[5])
            .then( res => {
            setCoins5(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk6() {
            axios.get(links[6])
            .then( res => {
            setCoins6(res.data)
            })
            .catch( error => console.log(error));
         }
         function lnk7() {
            axios.get(links[7])
            .then( res => {
            setCoins7(res.data)
            })
            .catch( error => console.log(error));
         }

        bannerCoin();
        lnk0();
        lnk1();
        lnk2();
        lnk3();
        lnk4();
        lnk5();
        lnk6();
        lnk7();


    }, []);

    //{/** Handlers start **/}

    const handleClickTrade = e => {
        window.location.href='./Trade';

        
    }

    const handleCoinSelect = e => {
        setCoinSelect(e.target.innerHTML);
        setPrice(e.target.value   * nairaRate);
        setCoinList(none);
        setCaretTo(caretDown);
        setAmount(e.target.value   * nairaRate);
        setAmountInputFrom(true);
        setSearchList('');
    }

    const handleSearchList = e => {
        setSearchList(e.target.value)
    };

    const handleSearch = e => {
        setSearch(e.target.value)
    };

    const handleMenu = e => {

      const newMenuIconState = menuIconState === open ? close : open;
      setMenuIconState(newMenuIconState);
      e.target.src = menuIconState;
      
      
      
        const newMenuState = menuState === none ? block : none;
        setMenuState(newMenuState);        
    
      
          const newMenuHeight = menuHeight === h1 ? h2 : h1;
          setMenuHeight(newMenuHeight);
      
      
          const newMenuColor = menuColor === gold ? blue : gold;
          setMenuColor(newMenuColor); 
      


    }

    

    const handleRateFromChange = e => {
        setAmount(e.target.value);
        setAmountInputFrom(true); 
    }
    const handleRateToChange = e => {
        setAmount(e.target.value);
        setAmountInputFrom(false);
    }

    const handleCaretTo = e => {
        const newCaretTo = caretTo === caretDown ? caretUp : caretDown;

        setCaretTo(newCaretTo);
        e.target.src = caretTo;

        const newCoinList = coinList === none ? block : none;

        setCoinList(newCoinList);

    };
    const handleArrow1 = e => {
        e.preventDefault();
       const newArrowState = arrow1 === up ? down : up;
        setArrow1(newArrowState);
    }
    const handleArrow2 = e => {
        e.preventDefault();
       const newArrowState = arrow2 === up ? down : up;
        setArrow2(newArrowState);
    }
    const handleArrow3 = e => {
        e.preventDefault();
       const newArrowState = arrow3 === up ? down : up;
        setArrow3(newArrowState);
    }
    const handleArrow4 = e => {
        e.preventDefault();
       const newArrowState = arrow4 === up ? down : up;
        setArrow4(newArrowState);
    }
    const handleArrow5 = e => {
        e.preventDefault();
       const newArrowState = arrow5 === up ? down : up;
        setArrow5(newArrowState);
    }
    const handleArrow6 = e => {
        e.preventDefault();
       const newArrowState = arrow6 === up ? down : up;
        setArrow6(newArrowState);
    }
    const handleArrow7 = e => {
        e.preventDefault();
       const newArrowState = arrow7 === up ? down : up;
        setArrow7(newArrowState);
    }

    const handleTerms = e => {
        window.location.href='./terms';
    }


     //{/** Handlers End */}

      //{/** coins filter start */}

   
      const filteredSearchCoins0 = coins0.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );
      const filteredSearchCoins1 = coins1.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );
      const filteredSearchCoins2 = coins2.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );
      const filteredSearchCoins3 = coins3.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );
      const filteredSearchCoins4 = coins4.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );
      const filteredSearchCoins5 = coins5.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );
      const filteredSearchCoins6 = coins6.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      ); 
      const filteredSearchCoins7 = coins7.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(searchList.toLowerCase())
      );


    const filteredCoins0 = coins0.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins1 = coins1.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins2 = coins2.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins3 = coins3.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins4 = coins4.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins5 = coins5.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins6 = coins6.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );
    const filteredCoins7 = coins7.filter(coin => (coin.name.toLowerCase() + coin.symbol.toLowerCase()).includes(search.toLowerCase())
    );

   

    const filteredBannerCoinsBtc = bannercoins.filter(bannercoin => (bannercoin.symbol.toUpperCase()) === "BTC");

    const filteredBannerCoinsUsdt = bannercoins.filter(bannercoin => (bannercoin.symbol.toUpperCase()) === "USDT");

    const filteredBannerCoinsEth = bannercoins.filter(bannercoin => (bannercoin.symbol.toUpperCase()) === "ETH");

    const filteredBannerCoinsLtc = bannercoins.filter(bannercoin => (bannercoin.symbol.toUpperCase()) === "LTC");

    //{/** coins filter end */}



    

    return (
        
        <div className='body'>
            <div className='head'>
                 <div className='header'>

      


                
                <p><img src={logo} alt=''  className='logo' /></p><p  className='logo-text'>Vhions Exchange</p>
                <div className='ul'>
                <ul>
                    <li  className='big-screen' onClick={handleClickTrade}>Buy Now</li>
                    <li className='big-screen' onClick={handleClickTrade}>Sell Now</li>
                    <li className='big-screen'><a href='#steps'>Steps</a></li>
                    <li className='big-screen'><a href='#testimonial' >Testimonials</a></li>
                    <li className='big-screen' onClick={handleTerms}>T&C's</li> 
                    <li className='big-screen'><a href='#faqs'>FAQ's</a></li>
                    <li  style={{background : menuColor}}><div><div className='img-div' style={{background : menuColor, height : menuHeight}}><img src={menuIconState} alt='' onClick={handleMenu}/></div>
                    <div className='menuList' style={{display: menuState}} onClick={handleMenu}>
                    <p onClick={handleClickTrade}> Buy Now</p>
                    <p onClick={handleClickTrade}> Sell Now</p>
                    <p><a href='#steps'> Steps </a></p>
                    <p><a href='#testimonials'>Testimonials</a></p>
                    <p onClick={handleTerms}>T&C's</p>
                    <p><a href='#faqs'>FAQ's</a></p>
                    </div></div>
                    </li>
                </ul>
                </div>
            </div>
            </div>
            <div className='banner col-xs-12'>
                <div className='welcome-text col-xs-4'>
                <p>Start your journey </p>
                <p>Into the universe</p>
                <p>Of Cryptocurrencies</p>
                <p>...buy, sell or swap your cryptos easily</p>
                <p>
                <button onClick={handleClickTrade}>Get Started</button>  
                </p>
                <br/>
                
                  <div><ul className='banner-ul small-screen'>
                  <li>{filteredBannerCoinsBtc.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                        <li>{filteredBannerCoinsUsdt.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                        <li>{filteredBannerCoinsEth.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                        <li>{filteredBannerCoinsLtc.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                      </ul></div>
                </div>
                <div className='col-xs-4'>
                    <img src={rocket} alt='' className='rocket col-xs-4' />
                </div>
                <div className='banner-ul col-xs-4 big-screen'>
                    <ul>
                        <li>{filteredBannerCoinsBtc.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                        <li>{filteredBannerCoinsUsdt.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                        <li>{filteredBannerCoinsEth.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                        <li>{filteredBannerCoinsLtc.map(bannercoin => {
                            return (
                                <BannerCoin
                                key={bannercoin.id}
                                image={bannercoin.image}
                                symbol={bannercoin.symbol}
                                price={bannercoin.current_price}
                                priceChange={bannercoin.price_change_percentage_24h}
                                nairaRate={nairaRate}
                                />
                            )
                        })}</li>
                    </ul>
                </div>
            </div>

            <div className='announcement'>
            <p>Announcement</p><span><p className='news'><ul>
                <li>Coin swapping feature will be added to the trading options soon. Stay tuned</li>
                <li>New Coin Listing : Waves, Litentry, Sand will be listed on 2nd December, 2021</li>
                <li>Here we are doing wonders. Happy Trading!!!</li>
                </ul></p></span>
            </div>

           

{/**  Converter table start*/} 
            <div className='converter col-xs-12'>
                <div className='col-xs-4'></div>
                <div className='col-xs-4 calc-div'>
                    <div className='calc-box'>
                    <div className='coin-from'>
                    
                    <div className='select-div'>
                    <input className='coin-select-input'  value='NGN' disabled/>
                    
                    
                    
                    
                         
                         <input type='number'  name='coin-from'  placeholder='amount' className='coin-from-input'  onChange={handleRateFromChange} value={Math.floor(fromAmount)} />  
                      </div>   
                         </div>
                         <div className='conv-box'>
                             {toAmount < 1 ? (
                                 <span className='conv-num'>{parseFloat(toAmount).toFixed(6)}</span>
                             ) : (
                                <span className='conv-num'>{parseFloat(toAmount).toLocaleString()}</span>
                             )}
                             <span className='conv-text'> {coinSelect} </span>
                             <span> = </span>
                             <span className='conv-text'> NGN </span>
                             <span className='conv-num'> {parseInt(fromAmount).toLocaleString()} </span>
                             </div>   
                        <div className='coin-from'>
                        <div className='select-div'>
                        <input className='coin-select-input' value={coinSelect} disabled/>
                    <img src={caretTo} alt='' onClick={handleCaretTo} className='caret'/>
                    
                    
                    <div className='coin-select-list' style={{display: coinList}}>
                    <input placeholder='search' className='search-list' onChange={handleSearchList} value={searchList} />
                        <ul className='coin-select-list-ul' onClick={handleCoinSelect}>
                            {filteredSearchCoins0.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>)
                                }</li>
                                
                            ) )} 
                            {filteredSearchCoins1.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}   
                                
                            {filteredSearchCoins2.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}
                            {filteredSearchCoins3.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}
                            {filteredSearchCoins4.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}
                            {filteredSearchCoins5.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}
                            {filteredSearchCoins6.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}
                            {filteredSearchCoins7.map( li => (
                                
                                <li key={li.id}>{li.current_price * nairaRate > 0.0005  ? (
                                    <button value={li.current_price}>{li.symbol.toUpperCase()}
                                    </button>
                                ) : 
                                  ( <button style={{color : 'red'}}>NAN</button>
                                )}</li>
                            ))}                                       
                                                     
                       
                    </ul></div>
                         
                         <input type='number'  name='coin-from'  placeholder='amount' className='coin-from-input' value={toAmount}  onChange={handleRateToChange} />
                         </div>
                         </div>
                    </div>
                </div>
                <div className='col-xs-4'></div>
            </div>
{/**  Converter table end*/} 



{/* coin table start */}

            <div className='coin-table col-xs-12'>
                <div className='col-xs-1'></div>
                <div className='col-xs-10 coin-table-div'>
                    <div className='search-div'>
                        <div className='search-box'>
                        <img src={searchicon} alt='search' />  <input placeholder='search' type='text' onChange={handleSearch}></input>
                        </div>
                    </div>
                    <div className='coin-table-head'>
                        <div className='market-name-div'>Markets</div>
                        <div className='market-data-div'>
                            <ul>
                                <li>current price</li>
                                <li>price change(24hr)</li>
                                <li>volume(24hr)</li>


                            </ul>
                        </div>
                    </div>
                    <div className='coin-screen'>
                    {filteredCoins0.map(coin => {
                        return (
                            
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })}
                    {filteredCoins1.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })}
                    {filteredCoins2.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })} 
                    {filteredCoins3.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })}
                   {filteredCoins4.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })} 
                    {filteredCoins5.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })}
                    {filteredCoins6.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })}
                    {filteredCoins7.map(coin => {
                        return (
                            <Coin 
                            key={coin.id}
                            image={coin.image}
                            name={coin.name}
                            symbol={coin.symbol}
                            price={coin.current_price}
                            priceChange={coin.price_change_percentage_24h}
                            volume={coin.total_volume}
                            nairaRate={nairaRate}

                            />
                        )
                    })}                                                                   
                    </div>
               
                </div>
                <div className='col-xs-1'></div>
                
            </div><br /><br />

 {/* coin table end */}

            <div className='howto' id='steps'>
                <h3 style={{background:'gold', padding:'5px', color:'black', fontWeight:'700'}}>Buy Crypto In 3 Steps. No Account Required!!!</h3>
                <div className='col-xs-4 step1'>
                    <div className='steps-textbox'><p style={{fontWeight:'700', paddingTop:'5px'}}>STEP 1</p>
                    <p>Click on the get started button to set up your trade on any of the listed cryptocurrency of your choice</p>
                    </div>
                </div>
                <div className='col-xs-4 step2'>
                 <div className='steps-textbox'><p style={{fontWeight:'700', paddingTop:'5px'}}>STEP 2</p>
                    <p>Select the trade type you want( buy or sell) and input all required information correctly. Proceed by clicking the buy/sell button</p>
                </div>
                </div>
                <div className='col-xs-4 step3'>
                 <div className='steps-textbox'><p style={{fontWeight:'700', paddingTop:'5px'}}>Final Step</p>
                    <p> Check your wallet within 5mins as your order will serviced instantly.<p style={{fontWeight:'700'}}>Happy Trading !!!</p></p>
                 </div>
                </div>
                
            </div>
            <div className='testimonials'>
                <div className='testimonial-box' id='testimonials'>
                  <ul>
                      <li><span style={{fontWeight:'700', fontSize:'18px'}}>" </span>Vhions Exchange is a place to be when it comes to buying and selling of your coins. They are reliable, legit, transparent, also they are trusted site to trade your Cryptos. When it comes to NFTs, Cryptos sales, They are fully guaranteed and genuine site to trade with. I do urge everyone to give a try and see the amazing trading services they will get.<br /><span style={{fontWeight:'700', fontSize:'18px'}}> "</span>
                          <p>-Chrystallus, Nigeria</p>
                      </li>
                      <li><span style={{fontWeight:'700', fontSize:'18px'}}>" </span> Vhion exchange is the best place to trade your cryto currency they are fast and reliable they buy and sell Bitcoin,Usdt and any Altcoin you can think of <span style={{fontWeight:'700', fontSize:'18px'}}> "</span>
                          <p>-Victor, Nigeria</p>
                      </li>
                      <li><span style={{fontWeight:'700', fontSize:'18px'}}>"</span>I really love using Vhions exchange. Fast reliable and the best so far<span style={{fontWeight:'700', fontSize:'18px'}}> "</span><p>-Temitayo, Nigeria</p></li>
                      <li><span style={{fontWeight:'700', fontSize:'18px'}}>" </span>testimony 4<span style={{fontWeight:'700', fontSize:'18px'}}> "</span><p>-Tunji, oyo</p></li>
                  </ul>
                </div>
            </div>
            <div className='faq-section' id='faqs'>
                <h3>Frequently Asked Questions</h3><br /><br />
                <p>About Vhions Exchange ?  <button onClick={handleArrow1} style={{float:"right"}}>{arrow1}</button><br />
                { arrow1 === up ? <p style={{background:'gold', marginTop:'10px'}}>We are a team of cryptocurrency traders and have been handling transactions successfully since 2018. </p> : <span></span>}
                </p>
                <p>Why is the coin I want to trade is not listed ? <button onClick={handleArrow2} style={{float:"right"}}>{arrow2}</button><br />
                { arrow2 === up ? <p style={{background:'gold', marginTop:'10px'}}>
                    Live chat the customer care support through the link, the order will be serviced immediately. New coin listings will also be announced in the announcement section.
                </p> : <span></span>}
                </p>
                <p>What is the minimum amount I can buy ? <button onClick={handleArrow3} style={{float:"right"}}>{arrow3}</button><br />
                    { arrow3 === up ? <p style={{background:'gold', marginTop:'10px'}}>
                        The minimum amount you can buy is ₦3,500. If the amount you want to trade is lesser than this, live chat the customer support.
                    </p> : <span></span>}
                </p>
                <p> What is the maximum amount I can buy ? <button onClick={handleArrow4} style={{float:"right"}}>{arrow4}</button> <br />
                    { arrow4 === up ? <p style={{background:'gold', marginTop:'10px'}}>
                        The maximum amount you can buy ₦3,000,000. If the amount you want to trade is higher than this, live chat the customer support.
                    </p> : <span></span>}
                </p>
                <p>What is the minimum amount I can sell ? <button onClick={handleArrow5} style={{float:"right"}}>{arrow5}</button><br />
                    { arrow5 === up ? <p style={{background:'gold', marginTop:'10px'}}>
                        The minimum amount you can sell is ₦1,000.
                    </p> : <span></span> }
                </p>
                <p>What is maximum amount I can Sell ? <button onClick={handleArrow6} style={{float:"right"}}>{arrow6}</button><br />
                    { arrow6 === up ? <p style={{background:'gold', marginTop:'10px'}}>
                        The maximum amount you can sell is ₦3,000,000. If the amount you want to order is more than this, live chat the customer suport.
                    </p> : <span></span> }
                </p>
                <p>When will my order be serviced ? <button onClick={handleArrow7} style={{float:"right"}}>{arrow7}</button> <br />
                   { arrow7 === up ?  <p style={{background:'gold', marginTop:'10px'}}>
                        Orders are serviced immediately, but as a result of blockchain confirmation, it might take up to 10-15minutes before you receive your coins. If your coin hasn't reflected in your wallet within 15minutes, live chat the customer support. 
                    </p> : <span></span>}
                </p>
            </div><br /><br />
        
            <div className='startnow'>
                <p>Join millions of crypto traders by starting Now</p>
                <br/>
                
                <p><button onClick={handleClickTrade}>Buy or Sell Now</button></p>
            </div>
            <div className='footer'>
                <span>©</span> 2021 Vhions Exchange <span><a href='https://www.twitter.com'><img src={twitter} alt='twitter'/></a><a href='https://wwww.facebook.com'><img src={facebook} alt='facebook'/></a><a href='https://wwww.gmail.com'><img src={gmail} alt='gmail'/></a></span>
            </div>

        

        </div> 
        
        
    )
}

export default App;

/** http://192.168.43.176:3000 */